// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__emi1T","header":"PatientBlock_header__1vq5j","label":"PatientBlock_label__2cNZW","option":"PatientBlock_option__36WIu"};